const Informacije = () => import("@views/app/information/information.vue");

export const informacijeRoutes = [
    {
        component: Informacije,
        name: "informacije_home",
        path: "informacije"
    },
];